import React, { useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import EmojiPicker from "emoji-picker-react";
import {
  getPosttypeChatlist,
  PostChat,
} from "../../../redux/chatandnotification/action";
import { useDispatch, useSelector } from "react-redux";
import CloudStorage from "../../../CloudStorage/CloudStorage";
import {
  getDownloadURL,
  getStorage,
  ref,
  uploadBytesResumable,
} from "firebase/storage";
import UploadChatFiles from "../UploadMultipleFilesinChat/UploadChatFiles";
import { Modal } from "reactstrap";
import { titlevalidation } from "../commonvalidation";

const ChatInputBox = ({ teamoverview, proposalmilestones }) => {
  const chatMessagesContainerRef = useRef(null);
  const [filemodel, setfileModel] = useState(false);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [loading, setLoading] = useState(false);
  const chatboxapidata = useSelector(
    ({ chatandnotification: { getposttypechatlist } }) => getposttypechatlist,
  );

  const dispatch = useDispatch();
  useEffect(() => {
    scrollToBottom();
  }, [chatboxapidata]);

  const scrollToBottom = () => {
    if (chatMessagesContainerRef.current) {
      chatMessagesContainerRef.current.scrollTop =
        chatMessagesContainerRef.current.scrollHeight;
    }
  };

  const formik = useFormik({
    initialValues: {
      message: "",
      image: null,
    },
    validationSchema: Yup.object({
      message: titlevalidation,
    }),
    onSubmit: async (values, { resetForm }) => {
      if (values.image && values.image.size > 10 * 1024 * 1024) {
        // 10MB size limit
        alert("File size should be less than 10MB");
        return;
      }

      let imageUrl = "";
      if (values.image) {
        const storage = getStorage();
        const storageRef = ref(
          storage,
          `AllChatReletedFiles/${values.image.name}`,
        );
        const uploadTask = uploadBytesResumable(storageRef, values.image);

        await new Promise((resolve, reject) => {
          uploadTask.on(
            "state_changed",
            null,
            (error) => reject(error),
            async () => {
              imageUrl = await getDownloadURL(uploadTask.snapshot.ref);
              resolve();
            },
          );
        });
      }

      const data = {
        type: "3",
        user_id: teamoverview?.company_id,
        post_id: "",
        message: values.message,
        image: imageUrl,
      };

      dispatch(PostChat(data, setLoading));
      scrollToBottom();
      setShowEmojiPicker(false);
      resetForm();
    },
  });

  const opentoselectmodel = () => {
    setfileModel(true);
  };

  const handleFileChange = (event) => {
    const file = event.currentTarget.files[0];
    formik.setFieldValue("image", file);
  };

  const handleEmojiSelect = (emojiObject) => {
    formik.setFieldValue("message", formik.values.message + emojiObject.emoji);
  };

  const toggleEmojiPicker = () => {
    setShowEmojiPicker((prevValue) => !prevValue);
  };

  return (
    <div>
      <form onSubmit={formik.handleSubmit}>
        <div className="chatbox-footer">
          <div className="chatbox-footer-first">
            <input
              type="text"
              className="form-control"
              placeholder="Write here"
              rows="1"
              name="message"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.message}
              onKeyDown={(event) => {
                if (event.key == "Enter" && !event.shiftKey) {
                  event.preventDefault();
                  if (loading) return;
                  formik.handleSubmit();
                }
              }}
            />
            <a onClick={toggleEmojiPicker} className="btn smile">
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/common/smile.svg`}
                alt=""
              />
              {showEmojiPicker ? "" : ""}
            </a>
            <div className="send-btn">
              {/* <input
                                type="file"
                                name="image"
                                onChange={handleFileChange}
                                style={{ display: 'none' }}
                                id="file-upload"
                            /> */}
              <label
                onClick={() => {
                  opentoselectmodel(true);
                }}
                htmlFor="file-upload"
                className="btn"
              >
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/common/attachment.svg`}
                  alt="Attach"
                />
              </label>
              <button type="submit" className="btn" disabled={loading}>
                {loading ? (
                  <span
                    className="spinner-border spinner-border-sm text-primary"
                    role="status"
                    aria-label="Sending"
                  />
                ) : (
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/common/send.svg`}
                    alt="Send"
                  />
                )}
              </button>
            </div>
          </div>
        </div>
      </form>
      {showEmojiPicker && <EmojiPicker onEmojiClick={handleEmojiSelect} />}
      <Modal
        size="xl"
        className="popupmodal rent-modal"
        isOpen={filemodel}
        toggle={() => setfileModel((state) => !state)}
      >
        <UploadChatFiles
          posts={teamoverview}
          type={3}
          setfileModel={setfileModel}
          id1={teamoverview?.company_id}
          id2={teamoverview?.company_id}
        />
      </Modal>
    </div>
  );
};

export default ChatInputBox;
